export enum OrderKind {
  PRODUCT = "product",
  SERVICE = "service",
  EVENT = "event",
  MIXED = "mixed",
  OTHER = "other",
}

export enum CheckoutSubmitType {
  AUTO = "auto",
  PAY = "pay",
  BOOK = "book",
  DONATE = "donate",
}

// export enum CheckoutStatus {
//   OPEN = "open",
//   READY = "ready",
//   COMPLETE = "complete",
//   EXPIRED = "expired",
// }

export enum PaymentType {
  PAYMENT = "payment",
  SETUP = "setup",
  SUBSCRIPTION = "subscription",
}

export enum ShippingMethodType {
  DELIVERY = "delivery",
  PICKUP_DELIVERY = "pickup_delivery",
  DROPOFF_DELIVERY = "dropoff_delivery",
  LOCAL_PICKUP = "local_pickup",
  LOCAL_DELIVERY = "local_delivery",
}
